module.exports = __webpack_public_path__ + "img/printer.91616540.svg";